export default "__VITE_ASSET__826410c5__"